import { FC } from "react";
import styles
    from "@/features/inspection-details/components/record-measurement/components/styles/MeasurementPass.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "@/store/rootReducer";
import { useTranslation } from "react-i18next";

interface MeasurementPassProps {
    selectedPass: number;
    updateSelectedPass: (selectedPass: number,) => void;
}

export const MeasurementPass: FC<MeasurementPassProps> = ({ selectedPass, updateSelectedPass }) => {
    const config = useSelector((state: RootState) => state.appConfig);
    const { t: translate } = useTranslation();
    return (
        <div className={styles.passesContainer}>
            <div className={styles.passesInnerContainer}>
                {Array.from({ length: config['size-check']?.passes || 3 }, (_, index) => (
                    <div
                        key={index}
                        className={`${styles.pass} ${selectedPass === index + 1 ? styles.passSelected : ''
                            }`}
                        onClick={() => updateSelectedPass(index + 1)}
                    >
                        {translate(config['size-check']?.passesTitles?.[index] || `Pass ${index + 1}`)}
                    </div>
                ))}
            </div>
        </div>
    )
}